import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const loginSendMobile = createAsyncThunk(
  "LOGIN_SEND_MOBILE",
  async ({ mobile, state }) => {
    const { data, status } = await axios.post("auth/", { mobile, state });
    return { data, status };
  }
);
//buildchange
export const loginWithPassword = createAsyncThunk(
  "LOGIN_WITH_PASSWORD",
  async ({ phoneNumber, password }) => {
    const { data, status } = await axios.post("login", {
      mobile: phoneNumber,
      password: password,
    });
    return { data, status };
  }
);

export const forgetPassword = createAsyncThunk(
  "LOGIN_FORGET_PASSWORD",
  async ({ mobile, state }) => {
    const { data, status } = await axios.post("api/send/", { mobile, state });
    return { data, status };
  }
);

export const forgetPasswordSendOpt = createAsyncThunk(
  "LOGIN_FORGET_PASSWORD_SEND_OTP",
  async ({ key, code }) => {
    const { data, status } = await axios.post("api/check/", { key, code });
    return { data, status };
  }
);

export const forgetPasswordChangePassword = createAsyncThunk(
  "LOGIN_FORGET_PASSWORD_CHANGE_PASSWORD",
  async ({ username, password }) => {
    const { data, status } = await axios.post("api/forget/", {
      username,
      password,
    });
    return { data, status };
  }
);

export const changePassword = createAsyncThunk(
  "LOGIN_CHANGE_PASSWORD",
  async ({ username, password }) => {
    const { data, status } = await axios.post("api/change_password/", {
      username,
      password,
    });
    return { data, status };
  }
);
